module.exports = __webpack_public_path__ + "img/noneBg.f409fc68.png";